import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LONG_RUNNING_PROCESS_QUIESCE_MODAL_HELP: HelpContent[] = [
    {
        helpContentId: 'long-running-process-quiesce-modal.message',
        tooltipText: 'Error message displayed to users when attempting to start a long-running process.',
        hasIcon: true
    }
];
